<template>
	<section>	
		<ul class="progressbar">
			<li :class="step == 'info' ? 'active' : 'done'">Info</li>
			<li :class="step == 'pengiriman' ? 'active' : '' || step == 'preview' ? 'done' : ''">Pengiriman</li>
			<li :class="step == 'preview' ? 'active' : ''" style="min-width: 129px;">Preview Perjalanan</li>
		</ul>

		<hr class="mt-5 mb-4 hide-on-mobile">
		<hr class="mt-4 mb-4 hide-on-web">	

		<section v-show="step == 'info'">
			<ValidationObserver tag="form" ref="val1">				
				<form @submit.prevent="setStep('pengiriman')">
					<p class="f-14 f-m-12 margin-0"><strong>Tanggal Perjalanan</strong></p>
					<div class="row">
						<div class="form-group mt-3 col margin-0">
							<label class="form-label">Tanggal</label>
							<ValidationProvider name="model.date" rules="required">
								<div class="input-group" :class="{ 'error': errors[0] }"
									slot-scope="{ errors }">
									<input type="text" class="form-control append-button" v-model="model.date" id="date" placeholder="Pilih tanggal" autocomplete="off" style="background-color:#fff; font-size: 17px;" >
									<div class="input-group-append"> 
										<span class="input-group-text">
											<i class="fas fa-calendar-alt"></i>
										</span>
									</div>
								</div>
							</ValidationProvider>                
						</div>
						<div class="col"></div>
					</div>    
					<hr>
					<p class="f-14 f-m-12 margin-0"><strong>Kota Asal dan Kota Tujuan</strong></p>
					<div class="row">
						<div class="form-group col ml-0 mr-2 m-m-0">
							<label class="form-label">Kota Asal</label>
							<ValidationProvider name="model.id_origin" rules="required">
								<model-list-select class="form-control f-12"
									:list			= params.rute
									:class			="{ 'error': errors[0] }"
									v-model			= model.id_origin
									option-value	= "id"
									option-text		= "name"
									placeholder		= "Pilih kota asal"									
									slot-scope		="{ errors }">
								</model-list-select>   
							</ValidationProvider>                
						</div>
						<div class="form-group col ml-0 mr-2 m-m-0">
							<label class="form-label">Kota Tujuan</label>
							<ValidationProvider name="model.id_destination" rules="required">
								<model-list-select class="form-control f-12"
									:list			= params.rute_tujuan
									:class			="{ 'error': errors[0] }"
									v-model			= model.id_destination
									option-value	= "id"
									option-text		= "name"
									placeholder		= "Pilih kota tujuan"									
									slot-scope		="{ errors }">
								</model-list-select>   
							</ValidationProvider>                
						</div>
					</div>
					<hr>
					<p class="f-14 f-m-12 margin-0"><strong>Data Driver</strong></p>
					<div class="row">
						<div class="form-group col ml-0 mr-2 m-m-0">
							<label class="form-label">Driver</label>
							<ValidationProvider name="selectedDriver" v-slot="{ errors }" rules="required">
								<multiselect 
									v-model="selectedDriver" 
									id="id" 
									track-by="id" 
									placeholder="Pilih driver" 
									:options="suggestDriver" 
									:multiple="false" 
									:class="{ 'error': errors[0] }"
									label="name"/>
							</ValidationProvider>
						</div>
						<div class="form-group col ml-0 mr-2 m-m-0">
							<label class="form-label">Asistant</label>
							<ValidationProvider name="model.id_asistant" v-slot="{ errors }">
								<multiselect 
									v-model="selectedAsistant" 
									id="id" 
									track-by="id" 
									placeholder="Pilih asisten driver" 
									:options="suggestAsistant" 
									:multiple="false" 
									:class="{ 'error': errors[0] }"
									label="name"/>
							</ValidationProvider>
						</div>
					</div> 
					<hr>
					<p class="f-14 f-m-12 margin-0"><strong>Device</strong></p>
					<div class="row">
						<div class="form-group col ml-0">
							<label class="form-label">Device</label>
							<input type="text" v-model="model.merk" class="form-control" disabled>
						</div>                   
						<div class="form-group col mr-0">
							<label class="form-label">Nomor telepon device</label>
							<input type="text" v-model="nomor_device" class="form-control" disabled>
						</div>  
					</div>
					<hr>
					<p class="f-14 f-m-12 margin-0"><strong>Kendaraan</strong></p>
					<div class="row">
						<div class="form-group col ml-0">
							<label class="form-label">Kendaraan</label>
							<multiselect 
								v-model="selectedVehicle" 
								id="id" 
								track-by="id" 
								placeholder="Pilih kendaraan" 
								:options="suggestVehicle" 
								:multiple="false" 
								:custom-label="customLabel"/>
						</div>                   
						<div class="form-group col mr-0">
							<label class="form-label">Nomor polisi</label>
							<input type="text" v-model="nomor_polisi" class="form-control" readonly>
						</div>  
					</div> 
					<hr>
					<button type="submit" class="w-m-1-2 float-right btn btn-primary col-2 mb-3 pd-10-20 text-white">Selanjutnya</button>
				</form>
			</ValidationObserver>
		</section>
		<section v-show="step == 'pengiriman'">	
			<ValidationObserver tag="form" ref="val2">
				<form @submit.prevent="setStep('preview')">
					<p class="f-14"><strong>Daftar Pengiriman</strong></p>            															
					<section v-if="selectedPengiriman.length == 0 && showList == false">
						<p class="f-12 mt-3">Silahkan lihat daftar pengiriman untuk memilih pengiriman yang akan dikirim</p>        
						<a @click="showList = true" class="btn btn-primary text-white">Buka Daftar Pengiriman</a> 
					</section>
					<section v-else-if="selectedPengiriman.length > 0 && showList == false">
						<div class="d-flex flex-wrap">
							<div class="heuBtn align-self-center hide-on-mobile" v-if="$route.params.type == 'loose'">
								<a @click="showList = true" class="btn btn-custom-sec d-block">
									<div class="mt-4 mb-4">
										<span><i class="fas fa-plus-circle c-prim" style="font-size: 35px;"></i></span>
										<p class="f-12 mt-2 c-prim">Tambah Daftar</p>
									</div>									
								</a>
							</div>
							<div class="hide-on-web w-m-full mb-2 ml-1 mr-1" v-if="$route.params.type == 'loose'">
								<a @click="showList = true" class="margin-0 btn btn-custom-sec w-m-full pd-10-20">
									<span><i class="fas fa-plus-circle"></i></span> Tambah Daftar
								</a>
							</div>
							<div class="heuheu" v-for="(data, index) in selectedPengiriman" :key="index">
								<div class="row">
									<div class="col">
										<p class="title-colee">Nama pengirim</p><p>{{data.pengirim.name}}</p>
									</div>
									<div class="col">
										<p class="title-colee">Tanggal dibuat</p><p>{{data.created_at | moment('DD-MM-yyyy')}}</p>
									</div>
								</div>
								<p class="title-colee">Kota asal pengiriman</p><p>{{data.pengirim.address}}</p>
								<p class="title-colee">Kota tujuan pengiriman</p><p>{{data.penerima.address}}</p>
								<div class="row">
									<div class="col">
										<p class="title-colee">Total barang</p><p><b>{{data.total_barang}}</b></p>
									</div>
									<div class="col">
										<p class="title-colee">Total berat</p><p><b>{{data.total_berat}} KG</b></p>
									</div>
									<div class="col">
										<p class="title-colee">Total volume</p><p><b>{{data.total_volume | round}} m3</b></p>
									</div>
								</div>
								<div class="row">
									<div class="col">
										<div class="float-right c-red margin-0">
											<a href="#" @click="removePengiriman(data)" class="mr-3 c-red">Hapus</a>
											<button type="button" @click="detail = data" data-toggle="modal" data-target="#modalDetailPerjalanan" class="btn btn-secondary ml-1">
												Lihat Detail
											</button>
										</div>
									</div>
								</div> 
							</div>
							<div class="heuheu hide-on-web">
								<div class="row">
									<div class="col">
										<p class="title-colee">Total Terpilih</p><b class="c-prim">{{selectedPengiriman.length}}</b>
									</div>
									<div class="col">
										<p class="title-colee">Kapasitas Tersisa</p><b class="c-red">{{totalSelected.total_kapasitas}} KG</b>
									</div>
								</div>
							</div>
						</div>
						<div class="ml-0 col hide-on-mobile">
							<div class="row">
								<div class="col-7 mr-2" style="background-color: #ffe8cf; border-radius: 4px; font-size: 12px; padding:10px 20px;">
									<div class="row">
										<div class="col">
											<p class="title-colee">Total pengiriman terpilih</p>
											<b>{{selectedPengiriman.length}}</b>
										</div>
										<div class="col">
											<p class="title-colee">Total berat</p>
											<b>{{totalSelected.total_berat}}</b>
										</div>
										<div class="col">
											<p class="title-colee">Total berat volume</p>
											<b>{{totalSelected.total_volume | round}} m3</b>
										</div>
									</div>    
								</div>
								<div class="col-3 mr-3" style="background-color: #ffd1cf; border-radius: 4px; font-size: 12px; padding:10px 20px;">
									<div class="col">
										<p class="title-colee">Kapasitas kendaraan tersisa</p>
										<b>{{totalSelected.total_kapasitas}} KG</b>
									</div>
								</div>
							</div>
						</div> 
					</section>
					<section v-show="showList">
						<p class="f-12 mt-3">Silahkan memilih pengiriman yang akan dikirim</p>        
						<div class="form-group">
							<div class="row">
								<div class="input-group col margin-0">
									<input type="text" v-model="search_invoice" class="form-control" placeholder="Cari nomor invoice / tanggal pengiriman" style="background-color:#f2f2f2; font-size: 14px;">
									<div class="input-group-append">
										<span class="input-group-text" style="background-color:#f5982f; color:#fff;"><i class="fas fa-search"></i></span>
									</div>
								</div> 
								<div class="col-8 hide-on-mobile margin-0 pd-0"></div>   
								<button data-toggle="modal" data-target="#modalFilter" class="hide-on-web btn btn-shadow margin-5">
									<img src="img/icon-2/On.png" alt="">
									<!-- <img src="img/icon-2/Off.png" alt="">-->
								</button>
							</div>    
							<div class="row mt-4 hide-on-mobile-inline">
								<p class="f-12 align-self-center margin-0"><strong>Filter</strong></p>
								<div class="form-group col mr-2 ml-4">
									<div class="input-group">
										<input type="text" id="date2" class="form-control append-button" placeholder="Pilih tanggal mulai" style="background-color:#fff; font-size: 14px;">
										<div class="input-group-append">
											<span class="input-group-text"><i class="fas fa-calendar-alt"></i></span>
										</div>
									</div>
								</div>                    
								<div class="form-group col mr-2">
									<select name="" class="form-control">
										<option value="">Pilih kota asal pengiriman</option>
									</select>                            
								</div>
								<div class="form-group col mr-2">
									<select name="" class="form-control">
										<option value="">Pilih kota tujuan pengiriman</option>
									</select>                            
								</div>                    
								<a @click="reset" class="link mr-5 ml-2 f-14 mt-2" href="#">Reset</a>
								<div class="form-group col mr-2"></div>
							</div>          
						</div>
						<section v-if="isLoading" class="text-center">
							<img src="/img/loading.gif" alt="Bisa Cek" class="mx-auto hide-on-mobile" style="width: 3%">
							<img src="/img/loading.gif" alt="Bisa Cek" class="mx-auto hide-on-web" style="width: 20%">
						</section>
						<section v-else>
							<div class="d-flex flex-wrap mx-auto mb-m-0 mt-3">
								<div class="heuheu" v-for="(data, index) in listPengiriman.data" :key="index">
									<div class="row">
										<div class="col">
											<p class="title-colee">Nama pengirim</p><p>{{data.pengirim.name}}</p>
										</div>
										<div class="col">
											<p class="title-colee">Tanggal dibuat</p><p>{{data.created_at | moment('DD-MM-yyyy')}}</p>
										</div>
									</div>
									<p class="title-colee">Kota asal pengiriman</p><p>{{data.pengirim.address}}</p>
									<p class="title-colee">Kota tujuan pengiriman</p><p>{{data.penerima.address}}</p>
									<div class="row">
										<div class="col">
											<p class="title-colee">Total barang</p><p><b>{{data.total_barang}}</b></p>
										</div>
										<div class="col">
											<p class="title-colee">Total berat</p><p><b>{{data.total_berat}} KG</b></p>
										</div>
										<div class="col">
											<p class="title-colee">Total volume</p><p><b>{{data.total_volume | round}} m3</b></p>
										</div>
									</div>
									<button type="button" v-if="selectedPengiriman.find(x => x.id === data.id)" @click="removePengiriman(data)" class="btn btn-secondary float-right">Batal</button>
									<button type="button" v-else @click="addPengiriman(data)" class="btn btn-primary float-right">Pilih</button>								
									<button type="button" @click="detail = data" data-toggle="modal" data-target="#modalDetailPerjalanan" class="btn btn-secondary float-right mr-2">Lihat Detail</button>
								</div>
							</div>  
						</section>
						<div class="mb-9 hide-on-mobile mt-4"><Pagination :data="listPengiriman"/></div>
						<div class="hide-on-web mx-auto mt-4"><Pagination :data="listPengiriman"/></div>
						<div class="heuheu hide-on-web">
							<div class="row">
								<div class="col">
									<p class="title-colee">Total Terpilih</p><b class="c-prim">{{selectedPengiriman.length}}</b>
								</div>
								<div class="col">
									<p class="title-colee">Kapasitas Tersisa</p><b class="c-red">{{totalSelected.total_kapasitas}}</b>
								</div>
							</div>
						</div>
						<div class="col align-self-center hide-on-web">
							<a @click="showList = false" class="btn btn-primary w-m-full pd-10-20 mb-4 text-white">Simpan</a>
						</div>
						<div class="barbar col-10 hide-on-mobile" style="z-index: 99;">
							<div class="row">
								<div class="col-7 mr-2" style="background-color: #ffe8cf; border-radius: 4px; font-size: 12px; padding:10px 20px;">
									<div class="row">
										<div class="col">
											<p class="title-colee">Total pengiriman terpilih</p>
											<b>{{selectedPengiriman.length}}</b>
										</div>
										<div class="col">
											<p class="title-colee">Total berat</p>
											<b>{{totalSelected.total_berat}} KG</b>
										</div>
										<div class="col">
											<p class="title-colee">Total berat volume</p>
											<b>{{totalSelected.total_volume | round}} m3</b>
										</div>
									</div>    
								</div>
								<div class="col-3 mr-3" style="background-color: #ffd1cf; border-radius: 4px; font-size: 12px; padding:10px 20px;">
									<div class="col">
										<p class="title-colee">Kapasitas kendaraan tersisa</p>
										<b>{{totalSelected.total_kapasitas}} KG</b>
									</div>
								</div>
								<div class="col align-self-center">
									<a @click="showList = false" class="btn btn-primary w-full pd-10-20 text-white">Simpan</a>
								</div>
							</div>
						</div>  
					</section>
					<hr>					
					<div v-show="showList == false" class="row float-right w-1-4 w-m-full">
						<a @click="step = 'info'" class="col btn btn-secondary margin-5 pd-10-20 c-prim">Kembali</a>
						<button type="submit" class="col btn btn-primary margin-5 pd-10-20">Selanjutnya</button>                    
					</div>            
				</form>
			</ValidationObserver>		
		</section>
		<section v-show="step == 'preview'">	
			<div class="row">
				<div class="col-2 margin-0 w-m-full no-flex pd-m-0">
					<p class="f-14 f-m-12"><strong>Info</strong></p>
				</div>
				<div class="col margin-0 f-14">
					<div class="row">
						<div class="col no-flex">
							<p class="title-colee f-12">Tipe perjalanan</p>
							<b>{{ this.$route.params.type == 'loose' ? 'Loose Load' : 'Full Load'}}</b>
						</div>
						<div class="col no-flex">
							<p class="title-colee f-12">Driver</p>
							<b>{{ model.name_driver }}</b>
						</div>
						<div class="col no-flex">
							<p class="title-colee f-12">Kendaraan</p>
							{{ model.type_kendaraan }} <br>
							<p class="f-12 text-secondary position-absolute"> {{ model.merk_kendaraan }}</p>
						</div>
					</div>
					<div class="row mt-2">
						<div class="col no-flex">
							<p class="title-colee f-12">Tanggal perjalanan</p>
							{{ model.date | moment('DD-MM-yyyy') }}
						</div>
						<!-- <div class="col no-flex">
							<p class="title-colee f-12">Asisten</p>
							{{ model.name_asistant }}
						</div> -->
						<div class="col no-flex">
							<p class="title-colee f-12">Nomor Polisi</p>
							<b>{{nomor_polisi}}</b>
						</div>
						<div class="col">
						</div>
					</div>
					<div class="row mt-2">
						<div class="col no-flex">
							<p class="title-colee f-12">Kota Asal Pengiriman</p>
							{{ rute_pengiriman.origin }}
						</div>
						<div class="col no-flex">
							<p class="title-colee f-12">Device</p>
							{{ model.merk }}
						</div>
						<div class="col">
						</div>
					</div>
					<div class="row mt-2">
						<div class="col no-flex">
							<p class="title-colee f-12">Kota Tujuan Pengiriman</p>
							{{ rute_pengiriman.destination }}
						</div>
						<div class="col no-flex">
							<p class="title-colee f-12">Nomor Telepon</p>
							<b>{{ nomor_device }}</b>
						</div>
						<div class="col">
						</div>
					</div>
				</div>    
			</div>
			<hr class="mt-4 mb-4">
			<div class="row">
				<div class="col-2 margin-0 w-m-full no-flex pd-m-0">
					<p class="f-14 f-m-12"><strong>Pengiriman</strong></p>
				</div>
				<div class="col margin-0 w-m-full">
					<div class="d-flex flex-wrap">
						<div class="heuheu" v-for="(data, index) in selectedPengiriman" :key="index">
							<div class="row">
								<div class="col">
									<p class="title-colee">Nama pengirim</p><p>{{data.pengirim.name}}</p>
								</div>
								<div class="col">
									<p class="title-colee">Tanggal dibuat</p><p>{{data.created_at | moment('DD-MM-yyyy')}}</p>
								</div>
							</div>
							<p class="title-colee">Kota asal pengiriman</p><p>{{data.pengirim.address}}</p>
							<p class="title-colee">Kota tujuan pengiriman</p><p>{{data.penerima.address}}</p>
							<div class="row">
								<div class="col">
									<p class="title-colee">Total barang</p><p><b>{{data.total_barang}}</b></p>
								</div>
								<div class="col">
									<p class="title-colee">Total berat</p><p><b>{{data.total_berat}} KG</b></p>
								</div>
								<div class="col">
									<p class="title-colee">Total volume</p><p><b>{{data.total_volume | round}} m3</b></p>
								</div>
							</div>
							<div class="row">
								<div class="col">
									<div class="float-right c-red margin-0">										
										<button type="button" @click="detail = data" data-toggle="modal" data-target="#modalDetailPerjalanan" class="btn btn-secondary ml-1">
											Lihat Detail
										</button>
									</div>
								</div>
							</div> 
						</div>
						<div class="heuheu hide-on-web">
							<div class="row">
								<div class="col">
									<p class="title-colee">Total Terpilih</p><b class="c-prim">{{selectedPengiriman.length}}</b>
								</div>
								<div class="col">
									<p class="title-colee">Kapasitas Tersisa</p><b class="c-red">{{totalSelected.total_kapasitas}} KG</b>
								</div>
							</div>
						</div>
					</div>
					<div class="ml-0 col hide-on-mobile">
						<div class="row">
							<div class="col-8 mr-2" style="background-color: #ffe8cf; border-radius: 4px; font-size: 12px; padding:10px 20px;">
								<div class="row">
									<div class="col">
										<p class="title-colee">Total pengiriman</p>
										<b>{{selectedPengiriman.length}}</b>
									</div>
									<div class="col">
										<p class="title-colee">Total berat</p>
										<b>{{totalSelected.total_berat}}</b>
									</div>
									<div class="col">
										<p class="title-colee">Total berat volume</p>
										<b>{{totalSelected.total_volume | round}} m3</b>
									</div>
								</div>    
							</div>
						</div>
					</div> 
				</div>
			</div>
			<hr class="mt-4 mb-4">
			<div class="row">
				<div class="col-2 margin-0 no-flex pd-m-0 w-m-1-2">
					<p class="f-14 f-m-12 margin-0"><strong>Keterangan Tambahan</strong></p>
				</div>
				<div class="col margin-0 f-12">
					<div class="row">
						<div class="col-6">
							<button class="info warning mb-2">{{ totalSelected.total_berat > totalSelected.total_kapasitas ? "Berat melebihi kapasitas kendaraan" : "Tidak ada" }}</button>
						</div>
					</div>
				</div>
			</div>
			<hr>
			<div v-show="step == 'preview'" class="row float-right w-1-4 w-m-full">
				<a @click="step = 'pengiriman'" class="col btn btn-secondary margin-5 pd-10-20 c-prim">Kembali</a>
				<button :disabled="isLoading" @click="create()" type="button" class="col btn btn-primary margin-5 pd-10-20">
					<i v-if="isLoading" class="fa fa-spinner fa-spin"></i> 
					<span v-if="!isLoading">Kirim</span>
				</button>                 
			</div>		
		</section>
		<div v-if="detail!=null" class="modal fade" id="modalDetailPerjalanan" tabindex="-1" role="dialog" aria-labelledby="modalDetailPerjalananTitle" aria-hidden="true">
			<div class="modal-dialog modal-dialog-centered modal-lg" role="document">
				<div class="modal-content mx-auto">
					<div class="modal-header">
						<h6 class="modal-title" id="modalDetailPerjalananTitle">
							<strong>Detail Pengiriman</strong>
						</h6>        
						<button type="button" class="close" data-dismiss="modal" aria-label="Close">
							<span aria-hidden="true">&times;</span>
						</button>        
					</div>
					<div class="modal-body">
						<div class="row">
							<div class="col">
								<p class="title-colee">Nomor Resi</p>
								<b>{{detail.no_resi}}</b>
							</div>
							<div class="col">
								<p class="title-colee">Nomor Faktur</p>
								{{detail.no_faktur}}
							</div>
							<div class="col">
								<p class="title-colee">Tipe Pengiriman</p>
								{{detail.type == 1 ? 'Kg' : 'Box'}}
							</div>	
						</div>  
						<div class="row">
							<div class="col">
								<p class="title-colee">Nama Pengirim</p>
								{{detail.pengirim.name}}
							</div>
							<div class="col">
								<p class="title-colee">Nama Penerima</p>
								{{detail.penerima.name}}
							</div>
							<div class="col">
								<p class="title-colee">Tanggal Dibuat</p>
								{{detail.created_at | moment('DD-MM-yyyy')}} {{detail.created_at | moment('HH:mm')}} WIB
							</div>
						</div> 
						<div class="row">
							<div class="col no-flex">
								<p class="title-colee">Alamat Asal Pengiriman</p>
								{{detail.pengirim.address}}
							</div>
							<div class="col no-flex">
								<p class="title-colee">Alamat Tujuan Pengiriman</p>
								{{detail.penerima.address}}
							</div>
						</div>
						<div class="row mt-4">
							<div class="heuheuheu" v-for="(data, index) in detail.barang" :key="index">
								<p class="title-colee">Nama Barang</p><p>{{data.name}}</p>
								<p class="title-colee">Berat</p><p>{{data.weight}} KG</p>
								<p class="title-colee">Berat Volume</p><p>{{data.volume | round}} m3</p>
								<p class="title-colee">Panjang x Lebar x Tinggi</p><p>{{data.length}} cm x {{data.width}} cm x {{data.tall}} cm</p>
							</div>
						</div>  
						<div class="mt-2" style="background-color: #ffe8cf; border-radius: 4px; font-size: 12px; padding:5px 10px;">
							<div class="row">
								<div class="col">
									<p class="title-colee">Total Barang</p>
									<b>{{detail.total_barang}}</b>
								</div>
								<div class="col">
									<p class="title-colee">Total Berat</p>
									<b>{{detail.total_berat}} KG</b>
								</div>
								<div class="col">
									<p class="title-colee">Berat Volume</p>
									<b>{{detail.total_volume | round}} m3</b>
								</div>
							</div>    
						</div>       
					</div>
				</div>
			</div>
		</div>
	</section>
</template>

<script>
import Pagination from '@/components/table/Pagination'
import Multiselect from 'vue-multiselect'
import { EventBus } from '@/plugins/bus.js'

export default {
	name: 'Form',
	components: {
		Multiselect,
		Pagination
	},
	data() {
		return {
			model: {
				id_rute: '',
			},
			rute_pengiriman: {
                namaDataPengiriman: '',
                price: '',
				col_price: '',
				origin: '',
				destination: '',
				id_origin: '',
				id_destination: ''
			},
			params : {
				rute: [],
				rute_tujuan: []
			},
			suggestDriver: 		[],
			suggestAsistant: 	[],
			suggestVehicle: 	[],
			step: 'info',
			nomor_device: null,
			nomor_polisi: null,
			listPengiriman: [],
			selectedPengiriman: [],
			totalSelected: {
				total_berat: 0,
				total_volume: 0,
				total_kapasitas: 0
			},
			showList: false,
			detail: null,
			search: {
				date_start: '',
				kota_asal: '',
				kota_tujuan: ''
			},
			search_invoice: '',
			isLoading: false,
			selectedVehicle: null,
			selectedDriver: null,
			selectedAsistant: null,
			page: 1
		}
	},
	beforeMount() {
		let _ = this
		_.setRandomCode()

		if ( _.$route.params.id ) {
			_.getData()
		}
	},
	methods: {
		setRandomCode() {
		    let _ = this
			_.model.randomcode = Math.floor(Math.random() * 9000000000) + 1000000000
		},
		customLabel ({ merk, nopol }) {
        	return `${merk} — ${nopol}`
        },
		create() {
			let _ = this
			_.isLoading = true

			let data = {
				id_origin: 		_.rute_pengiriman.origin_id,
				id_destination: _.rute_pengiriman.destination_id,
				id_driver_1: 	_.model.id_driver,
				id_driver_2: 	_.model.id_asistant,
				id_device: 		_.model.id_device,
				id_vehicle: 	_.model.id_kendaraan,
				type: 			_.$route.params.type == 'loose' ? 1 : 2,
				randomcode: 	_.model.randomcode
			}
			_.axios.post('expedition', data).then(resp => {
				_.createSelectedPengiriman()
				if ( resp.data.status ) {									
					_.$router.push({
						name: 'ExpeditionIndex',
						params: {
							status: 'insert'
						}
					})						
				}
				_.isLoading = false
			})
			.catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
				_.isLoading = false
			})
		},
		createSelectedPengiriman() {
            let _ = this
            _.selectedPengiriman.map(function(value) {                
                _.axios.post('/expedition/shipment', {
					randomcode: 	_.model.randomcode,
					id_pengiriman: 	value.id
				}).catch(err => {
					this.$toast.open({
						message: err.response.data.message,
						type: "error"
					})
				})
            });            
            return true
		},
		update() {
			let _ = this
			let update = {
				id: _.$route.params.id,
				..._.model
			}

			_.axios.patch('/expedition', update).then(resp => {
				if ( resp.data.status ) {
					_.$router.push({
						name: 'ExpeditionIndex',
						params: {
							status: 'update'
						}
					})
				}
			})
			.catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		getListPengiriman(){
		console.log('getListPengiriman');
            let _ = this
			_.isLoading = true
            _.axios.get('/shipment?status=1&rute=' + _.model.id_rute + 
				'&key=' + _.search_invoice +
				'&date=' + _.search.date_start + 
				'&origin_id=' + _.search.kota_asal + 
				'&destination_id=' + _.search.kota_tujuan + 
				'&limit=9' + 
				'&page=' + _.page
			).then(resp => {
				_.listPengiriman = resp.data.data.rows	
				_.isLoading = false			
			}).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
				_.isLoading = false
			})
        },
		getDataPengiriman(){
            let _ = this
            _.axios.get('/pricelist').then(resp => {
				_.params.rute = resp.data.data.rows								
			}).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		getDestination(){
            let _ = this
            _.axios.get('/pricelist?id_origin=' + _.model.id_origin).then(resp => {
				_.params.rute_tujuan = resp.data.data.rows				
			}).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
        },
        getRutePengiriman(){
            let _ = this
            _.axios.get('/pricelist?id_origin=' + _.model.id_origin + '&id_destination=' + _.model.id_destination).then(resp => {
				// _.rute_pengiriman.namaDataPengiriman 	= resp.data.data.rows[0].col_rute
				_.rute_pengiriman.price 				= resp.data.data.rows[0].price
				// _.rute_pengiriman.col_price 			= resp.data.data.rows.col_price				
				_.rute_pengiriman.origin				= resp.data.data.rows[0].origin.kabupaten
				_.rute_pengiriman.destination			= resp.data.data.rows[0].destination.kabupaten
				_.rute_pengiriman.origin_id				= _.model.id_origin
				_.rute_pengiriman.destination_id		= _.model.id_destination
				_.model.id_rute = resp.data.data.rows[0].id				
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},	
		getDevice(){
            let _ = this
            _.axios.get('/device?id=' + _.model.id_device).then(resp => {
				_.model.merk 	= resp.data.data.rows.merk
				_.nomor_device  = resp.data.data.rows.phone_number
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		addPengiriman(x){
			let _ = this

			if (_.$route.params.type == 'full'){
				if (_.selectedPengiriman.length == 1){
					this.$toast.open({
						message: "Tidak bisa menambahkan pengiriman lebih dari 1.",
						type: "error"
					})
					return;
				}
			}

			if (x.total_berat > _.totalSelected.total_kapasitas){
				this.$toast.open({
					message: "Kapasitas kendaraan tidak mencukupi.",
					type: "error"
				})
			}

			_.selectedPengiriman.push(x)
			_.totalSelected.total_berat 	+= x.total_berat
			_.totalSelected.total_volume 	+= x.total_volume
			_.totalSelected.total_kapasitas -= x.total_berat 
		},
		removePengiriman(x){
			let _ = this
			_.selectedPengiriman = _.selectedPengiriman.filter(function( obj ) {				
				return obj.id !== x.id;
			});

			_.totalSelected.total_berat 	-= x.total_berat
			_.totalSelected.total_volume 	-= x.total_volume
			_.totalSelected.total_kapasitas += x.total_berat 
		},
		async setStep(x) {
			let _ 	= this
			
			if (x == 'pengiriman'){
				const isValid = await this.$refs.val1.validate();
				if (!isValid) {		
					return;
				}

				if (_.model.id_kendaraan == null){
					this.$toast.open({
						message: "Kendaraan harus dipilih.",
						type: "error"
					})
					return;
				}

				/*
				if(_.model.id_asistant == null){
					this.$toast.open({
						message: "Asisten driver harus dipilih.",
						type: "error"
					})
					return;
				}
				*/
				
				if (_.model.id_driver == _.model.id_asistant){
					this.$toast.open({
						message: "Driver dan asisten harus berbeda.",
						type: "error"
					})
					return;
				}

				_.getListPengiriman()
				_.step = x
			}
			if (x == 'preview'){
				if (this.selectedPengiriman.length == 0){
					this.$toast.open({
						message: "Silahkan pilih pengiriman.",
						type: "error"
					})					
					return;
				}
				_.step = x
			}			
		},
		searchNamaDriver(input) {
		    let _ = this
			_.axios.get('/driver?status=1&is_driver=true&key=' + input).then(resp => {
                _.suggestDriver[0].data = resp.data.data.rows.data
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		searchNamaAsistant(input) {
		    let _ = this
			_.axios.get('/driver?status=1&is_assistant=true&key=' + input).then(resp => {
                _.suggestAsistant[0].data = resp.data.data.rows.data
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		getVehicle() {
		    let _ = this
			_.axios.get('/vehicle?status=1').then(resp => {
                _.suggestVehicle = resp.data.data.rows
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		setValueOrigin(val) {
			let _ = this
			_.search.kota_asal = val			
			_.getListPengiriman()
		},
		setValueDestination(val) {
			let _ = this
			_.search.kota_asal = val			
			_.getListPengiriman()
		},
		reset(){
			let _ = this			

			document.getElementById('date2').value = ''

			_.search = {
				date_start	: "",
				kota_asal	: "",
				kota_tujuan	: ""
			}
			_.getListPengiriman()
		},
		getDriver() {
		    let _ = this
			_.axios.get('/driver?status=1&is_driver=true').then(resp => {
                _.suggestDriver = resp.data.data.rows
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
		getAssistant() {
		    let _ = this
			_.axios.get('/driver?status=1&is_assistant=true').then(resp => {
                _.suggestAsistant = resp.data.data.rows
            }).catch(err => {
				this.$toast.open({
					message: err.response.data.message,
					type: "error"
				})
			})
		},
	},
	beforeDestroy(){
		EventBus.$off('changePage' + this.routeName)
    },
	watch: {
		'model.id_origin': function () {		
			this.getDestination()
		},
		'model.id_destination' : function(){
			this.getRutePengiriman()			
		},
		search_invoice : function(){
			this.getListPengiriman()
		},
		selectedVehicle: function(){
			let _ = this
			_.model.id_kendaraan			= _.selectedVehicle.id
			_.nomor_polisi					= _.selectedVehicle.nopol
			_.model.merk_kendaraan			= _.selectedVehicle.merk
			_.totalSelected.total_kapasitas = _.selectedVehicle.kapasitas	
			_.model.type_kendaraan		    = _.selectedVehicle.type
		},
		selectedDriver() {
		    let _ 							= this
			_.model.id_driver		        = _.selectedDriver.id
			_.model.name_driver				= _.selectedDriver.name
			_.model.id_device				= _.selectedDriver.id_device
			_.getDevice()	
		},
		selectedAsistant() {
		    let _ 							= this
			_.model.id_asistant		        = _.selectedAsistant.id
			_.model.name_asistant			= _.selectedAsistant.name
		}
	},
	created(){
        let _ = this
		_.getDataPengiriman()
		_.getVehicle()
		_.getDriver()
		_.getAssistant()
	},
	mounted(){
		let _ = this
		$('#date').datepicker().on('changeDate', function(e) {			
			_.model.date = e.format('yyyy-mm-dd')						
		});
		$('#date2').datepicker().on('changeDate', function(e) {			
			_.search.date_start = e.format('yyyy-mm-dd')			
			_.getListPengiriman()			
		});
		EventBus.$on('changePage' + this.$route.name, page => {
			_.page = page
			_.getListPengiriman()
		})
	}
}
</script>